type PublicStats = {
  activeCreators?: number;
  availableClasses?: number;
  totalSessions?: number;
  totalStudents?: number;
} | null;

export default function CommunityStats({ publicStats }: { publicStats: PublicStats }) {
  const toNum = (v: unknown) => {
    const n = Number(v);
    return Number.isFinite(n) ? (n as number) : 0;
  };

  const stats = {
    activeCreators: toNum(publicStats?.activeCreators),
    availableClasses: toNum(publicStats?.availableClasses),
    totalStudents: toNum(publicStats?.totalStudents),
    totalSessions: toNum(publicStats?.totalSessions),
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      <div className="bg-card border border-border rounded-2xl p-6 text-center shadow-lg">
        <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
          {stats.activeCreators.toLocaleString()}
        </div>
        <div className="text-sm md:text-base text-muted-foreground font-medium">
          Active Creators
        </div>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 text-center shadow-lg">
        <div className="text-3xl md:text-4xl font-bold text-green-600 mb-2">
          {stats.availableClasses.toLocaleString()}
        </div>
        <div className="text-sm md:text-base text-muted-foreground font-medium">
          Classes Available
        </div>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 text-center shadow-lg">
        <div className="text-3xl md:text-4xl font-bold text-orange-600 mb-2">
          {stats.totalStudents.toLocaleString()}
        </div>
        <div className="text-sm md:text-base text-muted-foreground font-medium">Students</div>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 text-center shadow-lg">
        <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">
          {stats.totalSessions.toLocaleString()}
        </div>
        <div className="text-sm md:text-base text-muted-foreground font-medium">Classes Taught</div>
      </div>
    </div>
  );
}
